import React, { Component } from 'react';
import Script from 'react-load-script';

class Job extends Component {
  initGrnhse() {
    if (window) {
      const { id } = this.props;
      window.Grnhse.Iframe.load(id);
    }
  }

  render() {
    return (
      <div id="grnhse_container">
        <div id="grnhse_app" />
        <Script
          url="https://boards.greenhouse.io/embed/job_board/js?for=formlabs"
          onLoad={this.initGrnhse.bind(this)}
        />
      </div>
    );
  }
}

export default Job;
